import request from '@/utils/request'

let CeApi = {

  /*测加应用列表*/
  list(data) {
    return request._post('/shop/plus.ce.Index/index', data);
},
/*添加测加应用*/
add(data) {
    return request._post('/shop/plus.ce.Index/add', data);
},
/*修改测加应用*/
edit(data) {
    return request._post('/shop/plus.ce.Index/edit', data);
},
/*删除测加应用*/
del(data) {
    return request._post('/shop/plus.ce.Index/del', data);
},
/*测加应用详情*/
detail(data) {
  return request._post('/shop/plus.ce.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ce.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ce.Setting/getSetting', data, errorback);
    },
}
export default CeApi;



// WEBPACK FOOTER //
// ./src/api/ce.js